var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgThIconTwitter(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_396_1523)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M29.8 0H2.2C1.53625 0 1 0.53625 1 1.2V28.8C1 29.4638 1.53625 30 2.2 30H29.8C30.4638 30 31 29.4638 31 28.8V1.2C31 0.53625 30.4638 0 29.8 0ZM24.0737 10.8638C24.085 11.04 24.085 11.2238 24.085 11.4038C24.085 16.9088 19.8925 23.25 12.2313 23.25C9.86875 23.25 7.67875 22.5638 5.83375 21.3825C6.17125 21.42 6.49375 21.435 6.83875 21.435C8.78875 21.435 10.5813 20.775 12.01 19.6575C10.18 19.62 8.6425 18.42 8.1175 16.77C8.75875 16.8638 9.33625 16.8638 9.99625 16.695C9.05397 16.5036 8.20703 15.9918 7.59931 15.2467C6.99159 14.5016 6.66057 13.569 6.6625 12.6075V12.555C7.21375 12.8663 7.8625 13.0575 8.54125 13.0838C7.97066 12.7035 7.50272 12.1883 7.17892 11.5839C6.85512 10.9794 6.68546 10.3044 6.685 9.61875C6.685 8.8425 6.8875 8.13375 7.25125 7.51875C8.29713 8.80626 9.60224 9.85928 11.0817 10.6094C12.5612 11.3595 14.182 11.7898 15.8388 11.8725C15.25 9.04125 17.365 6.75 19.9075 6.75C21.1075 6.75 22.1875 7.2525 22.9487 8.0625C23.89 7.88625 24.79 7.53375 25.5925 7.06125C25.2812 8.025 24.6288 8.83875 23.7625 9.3525C24.6025 9.2625 25.4125 9.03 26.1625 8.70375C25.5963 9.53625 24.8875 10.275 24.0737 10.8638Z",
    fill: "#46ACED"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_396_1523",
    x: 0,
    y: 0,
    width: 32,
    height: 32,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_396_1523"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_396_1523",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgThIconTwitter);
export default __webpack_public_path__ + "static/media/TH-Icon-Twitter.8cff2815cc79c476e436fbb7cde8af7b.svg";
export { ForwardRef as ReactComponent };